import moment from "moment-timezone";
import { accountDetailsApi } from "../api/SessionServiceManager";
import { getRoleByUser, editRoles, getRoles } from "../model/roleService";
import { DATE_FORMAT_MMDDYYYY } from "../global/constants/statistics.dateConstants";
import { clearAuthStorage } from "../global/axiosInterceptor";
import { ADVANCED_CONFIG } from "../constants/enrolledAppearanceConstants";

export const getValue = (obj, key) => {
  if (typeof obj !== "object" || obj === null) return null;
  if (key in obj) return obj[key];

  for (const k in obj) {
    if (typeof obj[k] === "object" && obj[k] !== null) {
      const value = getValue(obj[k], key);
      if (value !== null) return value;
    }
  }
  return null;
};

export const getNestedValue = (obj, key) => {
  if( typeof obj !== "object" || obj === null) return null;

  if(key in obj) {
    const value = obj[key];
    if(value !== null && !(typeof value === "object" && Object.keys(value).length === 0)) {
      return value;
    }
  }

  for(const k in obj) {
    if(typeof obj[k] === "object" && obj[k] !== null) {
      const value = getNestedValue(obj[k], key);
      if(value !== null) return value;
    }
  }
  return null;
};

export const minMax = points => {
    return points.reduce(
      (acc, val) => {
        acc[0] = val < acc[0] ? val : acc[0]
        acc[1] = val > acc[1] ? val : acc[1]
        return acc
      },
      [Infinity, -Infinity]
    )
  }
  
  export const getMiddlePoint = points => {
    const x = points.reduce((acc, val) => acc + val[0], 0) / points.length
    const y = points.reduce((acc, val) => acc + val[1], 0) / points.length
    return { x, y }
  }
  
  export const adjustPolygonPoints = (originalSize,polygonPoints, newSize) => {
    const [originalWidth, originalHeight] = originalSize;
    const [newWidth, newHeight] = newSize;
    const scaleX = parseInt(newWidth) / parseInt(originalWidth);
    const scaleY = parseInt(newHeight) / parseInt(originalHeight);
   // console.log(originalSize,originalHeight, scaleX, scaleY, "adjustPoints >>>");

    return polygonPoints.map(([x,y])=>[x * scaleX, y * scaleY]);
  
  }
  export const getPoints = (points) => {
    let merged = [];
    points.map((ponit, index) => {
      const mapping1 = {
        ["pointA"]: { x: parseInt(ponit[0]), y: parseInt(ponit[1]) },
      };
      let mapping2 = {};
      if (points.length - 1 === index) {
        mapping2 = {
          ["pointB"]: { x: parseInt(points[0][0]), y: parseInt(points[0][1]) },
        };
      } else {
        mapping2 = {
          ["pointB"]: {
            x: parseInt(points[index + 1][0]),
            y: parseInt(points[index + 1][1]),
          },
        };
      }
      const res = { ...mapping1, ...mapping2 };
      merged.push(res);
    });
    return merged;
  };
  export const getSplitPoints = (points, x, y) => {
    let merged = [];
    points.map((ponit, index) => {
      const mapping1 = {
        ["pointA"]: { x: parseInt(ponit[0]), y: parseInt(ponit[1]) },
      };
      let mapping2 = {};
      if (points.length - 1 === index) {
        mapping2 = {
          ["pointB"]: { x: parseInt(x), y: parseInt(y) },
        };
      } else {
        mapping2 = {
          ["pointB"]: {
            x: parseInt(points[index + 1][0]),
            y: parseInt(points[index + 1][1]),
          },
        };
      }
      const res = { ...mapping1, ...mapping2 };
      merged.push(res);
    });
    return merged;
  };
 export const getUniquePoints = (RoiData) => {
  if (!Array.isArray(RoiData)) return [];
  const uniquePoints = [];
  RoiData.forEach((data) => {
    if (!data?.points) return;
    const currentFlat = data.points.flat();
    const isDuplicate = uniquePoints.some((roi) => {
      const roiFlat = roi.points.flat();
      return areArraysEqual(currentFlat, roiFlat);
    });
    if (!isDuplicate) {
      uniquePoints.push(data);
    }
  });
  return uniquePoints;
};

  export const isPolygonClosed = points => {
    return points.length >= 3
    // const first = points[0];
    // const last = points[points.length - 1];
    // return first[0] === last[0] && first[1] === last[1];
  }

  export const getAvaragePoint = (points) => {
    let totalX = 0;
    let totalY = 0;
    for (let i = 0; i < points.length; i += 2) {
      totalX += points[i];
      totalY += points[i + 1];
    }
    return {
      x: totalX / (points.length / 2),
      y: totalY / (points.length / 2),
    };
  };
  export const getDistance = (node1, node2) => {
    let diffX = Math.abs(node1[0] - node2[0]);
    let diffY = Math.abs(node1[1] - node2[1]);
    const distaneInPixel = Math.sqrt(diffX * diffX + diffY * diffY);
    return Number.parseFloat(distaneInPixel).toFixed(2);
  };
  export const dragBoundFunc = (stageWidth, stageHeight, vertexRadius, pos) => {
    let x = pos.x;
    let y = pos.y;
    if (pos.x + vertexRadius > stageWidth) x = stageWidth;
    if (pos.x - vertexRadius < 0) x = 0;
    if (pos.y + vertexRadius > stageHeight) y = stageHeight;
    if (pos.y - vertexRadius < 0) y = 0;
    return { x, y };
  };
  export const minMax1 = (points) => {
    return points.reduce((acc, val) => {
      acc[0] = acc[0] === undefined || val < acc[0] ? val : acc[0];
      acc[1] = acc[1] === undefined || val > acc[1] ? val : acc[1];
      return acc;
    }, []);
  };

  export const modifyNestedKeyValues = (obj, keyToCheck = "") => {
    if (typeof obj !== "object" || obj === null) return obj;

    for (const key in obj) {
      let value = obj[key];

      if (typeof value === "object" && !Array.isArray(value)) {
        obj[key] = modifyNestedKeyValues(value);
      } else if (Array.isArray(value)) {
        obj[key] = value.map((item) =>
          typeof item === "object"
            ? modifyNestedKeyValues(item)
            : convertStringIfNumber(item)
        );
      } else if (
        key.toLowerCase().includes("colors") &&
        (value === "" || value === 0)
      ) {
        obj[key] = [];
      } else {
        obj[key] = convertStringIfNumber(value);
      }

      if(key === ADVANCED_CONFIG.ENABLE_APPEARANCE){
        if(obj[key] !== true){
          const {is_color_exclusion_set, colors, ...rest} = obj;
          obj = rest;
        }
      }
    }
    return obj;
  };

  const convertStringIfNumber = (val) => {
    if (
      typeof val === "string" &&
      val.trim() !== "" &&
      !isNaN(val.trim()) &&
      isFinite(val.trim())
    ) {
      return Number(val.trim());
    }
    return val;
  };

  export const sortedObject = (obj) => {
    const result = {};
    const enumKeys = [];
    const nonEnumKeys = [];
    for (const key in obj) {
      if (
        obj[key] &&
        typeof obj[key] === "object" &&
        obj[key].hasOwnProperty("enum")
      ) {
        enumKeys.push(key);
      } else {
        nonEnumKeys.push(key);
      }
    }
    for (const key of nonEnumKeys) {
      result[key] = obj[key];
    }
    for (const key of enumKeys) {
      result[key] = obj[key];
    }
    return result;
  };

export const isWithin24Hour = (date_string) => {
  const now = new Date();
  const diffTime = now - new Date(date_string);
  const diffHours = diffTime / (1000 * 60 * 60);
  return diffHours <= 24;
};

export function filterArrayBySiteId(array1, array2){
  const siteIdSet = new Set(array1.map(item => item.id));

  function filterChildren(items){
    return items.map(item => {
      if(item.siteid){
        return siteIdSet.has(item.siteid) ? item : null;
      } else if (item.children){
        const filteredChildren = filterChildren(item.children).filter(Boolean);
        return filteredChildren.length > 0 ? {...item, children: filteredChildren} : null;
      }
      return item;
    }).filter(Boolean);
  }
  return filterChildren(array2);
}

export const formattedTimeStamp = (timeStamp) => {
  const timeZone = moment.tz.guess();
  let regex = /^(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})$/;
  if (timeStamp.includes("Z") || timeStamp.includes("z")) {
    const formatted = moment(timeStamp).tz(timeZone);
    return {
      time: formatted.format("hh:mm A z"),
      date: formatted.format("MMM. DD, YYYY")
    };
  } else if (regex.test(timeStamp)) {
    const formatted = moment(timeStamp, "DD/MM/YYYY, HH:mm:ss").tz(timeZone);
    return {
      time: formatted.format("hh:mm A z"),
      date: formatted.format("MMM. DD, YYYY")
    };
  } else {
    return { time: timeStamp, date: "" };
  }
};

  export const getFormattedDate = (timeStamp) => {
    if (timeStamp) {
      return moment(timeStamp).format(DATE_FORMAT_MMDDYYYY);
    }
    return "";
  };

export const sessionStorageValues = async (access_token) => {
  if (access_token) {
    const accountDetails = await accountDetailsApi(access_token);
    sessionStorage.setItem("accountDetails", JSON.stringify(accountDetails));
    sessionStorage.setItem("accountId", accountDetails.billingaccountid);
    let activeSession = {
      userId: accountDetails.id,
      userName: accountDetails.email,
      firstName: accountDetails.firstname || "",
      sessionToken: access_token,
      accountId: accountDetails.billingaccountid,
    };
    sessionStorage.setItem("updatedDate", new Date());

    const roleByUser = await getRoleByUser(activeSession, accountDetails.id);

    if (roleByUser && Array.isArray(roleByUser) && roleByUser.length > 0) {
      sessionStorage.setItem(
        "selectedRole",
        JSON.stringify(roleByUser[0].name)
      );
      const rolePermissionsList = await editRoles(
        activeSession,
        roleByUser[0].id
      );
      sessionStorage.setItem(
        "rolePermissionsList",
        JSON.stringify(rolePermissionsList)
      );
    } else {
      // null = API/network failure; [] = user genuinely has no role assigned.
      // Both cases: deny by default — surface modal so user can explicitly retry (logout happens on modal "Try Again").
      const errorMsg = roleByUser === null
        ? "Unable to verify your account role due to a service error. Please try again later."
        : "No role is assigned to your account. Please contact your administrator.";
      console.error("Role check failed:", errorMsg);
      clearAuthStorage();
      const err = new Error("role_unavailable");
      err.roleErrorMsg = errorMsg;
      throw err;
    }
  }
};

export const getArrayAsText = (arr) => {
  let msg = "";
  if(arr && Array.isArray(arr)){
    arr.forEach((e, index) => msg += e + `${arr.length - 1 === index ? "" : ", "}`);
    return msg;
  }
  return "";
}

export const areArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};